import { Segmented } from 'antd';
import { useTranslation } from 'react-i18next';

import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '@/i18n';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current: SupportedLanguage = i18n.language.startsWith('fr') ? 'fr' : 'en';

  return (
    <Segmented
      size="small"
      value={current}
      onChange={(value) => {
        void i18n.changeLanguage(value as SupportedLanguage);
      }}
      options={SUPPORTED_LANGUAGES.map((code) => ({
        label: code.toUpperCase(),
        value: code,
      }))}
      aria-label="Language switcher"
    />
  );
}
